import type { Block, Inline } from '@contentful/rich-text-types';
import type { GqlKbArticleRichTextEntry } from '../../../../content/types/content/kb-article';
import type { GqlCalloutRichTextHyperlinkEntry } from '../../../../content/types/content/component-callout';

type GqlKbRichTextEntry =
    | GqlKbArticleRichTextEntry
    | GqlCalloutRichTextHyperlinkEntry;

const getEntryFromNode = <T extends GqlKbRichTextEntry>(
    node: Block | Inline,
    entryMap: Map<string, T>
): T | null => {
    const embeddedId = node.data.target?.sys?.id;

    if (!embeddedId) {
        return null;
    }

    const entry = entryMap.get(embeddedId);

    if (!entry) {
        // Entry might be null in GraphQL response or filtered out
        // Return null instead of throwing to allow graceful degradation
        return null;
    }

    return entry;
};

export default getEntryFromNode;
